<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="Edit Customer" scrollable hide-footer>
            <template v-slot:modal-title>
                <span>Edit Customer:</span>
            </template>

            <b-form v-if="ready" @submit.stop.prevent="editCustomer">
                <b-row>
                    <b-col>
                        <b-form-group
                            id="input-group-name"
                            label="Name:"
                            label-for="input-name"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="edit.name"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-company"
                            label="Company:"
                            label-for="input-company"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-company"
                                v-model="edit.company"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-buyer-name"
                                    label="Buyer Name:"
                                    label-for="input-buyer-name"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-buyer-name"
                                        v-model="edit.buyerName"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="select-group-sales-rep"
                                    label="Sales Rep:"
                                    label-for="select-sales-rep"
                                    label-size="sm"
                                >
                                    <b-form-select
                                        v-model="edit.salesRepId"
                                        id="select-sales-rep"
                                        size="sm"
                                        :options="lists.salesReps"
                                    ></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>

                    <b-col>
                        <b-form-group
                            id="input-group-email"
                            label="Email:"
                            label-for="input-email"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-email"
                                v-model="edit.email"
                                type="text"
                                placeholder=""
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>

                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="input-group-phone"
                                    label="Phone:"
                                    label-for="input-phone"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-phone"
                                        v-model="edit.phone"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-mobile"
                                    label="Mobile:"
                                    label-for="input-mobile"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-mobile"
                                        v-model="edit.mobile"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    id="input-group-fax"
                                    label="Fax:"
                                    label-for="input-fax"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-fax"
                                        v-model="edit.fax"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row>
                            <!-- <b-col cols="4">
                                <b-form-group
                                    id="input-group-other"
                                    label="Other:"
                                    label-for="input-other"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-other"
                                        v-model="edit.other"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col> -->
                            <b-col cols="12">
                                <b-form-group
                                    id="input-group-website"
                                    label="Website:"
                                    label-for="input-website"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-website"
                                        v-model="edit.website"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-row>

                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Address" active>
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <p>Billing Address:</p>
                                        <b-form-group
                                            id="textarea-group-billing-address-1"
                                        >
                                            <b-form-input
                                                id="input-billing-address-1"
                                                v-model="edit.billingAddress1"
                                                type="text"
                                                placeholder="Address 1"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-billing-address-2"
                                        >
                                            <b-form-input
                                                id="input-billing-address-2"
                                                v-model="edit.billingAddress2"
                                                type="text"
                                                placeholder="Address 2"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-city"
                                                >
                                                    <b-form-input
                                                        id="input-billing-city"
                                                        v-model="edit.billingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-state"
                                                >
                                                    <b-form-input
                                                        id="input-billing-state"
                                                        v-model="edit.billingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-zip"
                                                >
                                                    <b-form-input
                                                        id="input-billing-zip"
                                                        v-model="edit.billingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-billing-country"
                                                >
                                                    <b-form-input
                                                        id="input-billing-country"
                                                        v-model="edit.billingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                    <b-col>
                                        <p>Shipping Address:</p>
                                        <b-form-group
                                            id="textarea-group-shipping-address-1"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-1"
                                                v-model="edit.shippingAddress1"
                                                type="text"
                                                placeholder="Address 1"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-group
                                            id="textarea-group-shipping-address-2"
                                        >
                                            <b-form-input
                                                id="input-shipping-address-2"
                                                v-model="edit.shippingAddress2"
                                                type="text"
                                                placeholder="Address 2"
                                                size="sm"
                                                autocomplete="off"
                                            >
                                            </b-form-input>
                                        </b-form-group>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-city"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-city"
                                                        v-model="edit.shippingCity"
                                                        type="text"
                                                        placeholder="City"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-state"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-state"
                                                        v-model="edit.shippingState"
                                                        type="text"
                                                        placeholder="State"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-zip"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-zip"
                                                        v-model="edit.shippingZip"
                                                        type="text"
                                                        placeholder="Zip"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-shipping-country"
                                                >
                                                    <b-form-input
                                                        id="input-shipping-country"
                                                        v-model="edit.shippingCountry"
                                                        type="text"
                                                        placeholder="Country"
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Notes">
                            <b-card-text>
                                <b-form-group
                                    id="textarea-group-notes"
                                    label="Notes:"
                                    label-for="textarea-notes"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-notes"
                                        v-model="edit.notes"
                                        placeholder=""
                                        rows="7"
                                        size="sm"
                                        no-resize
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Tax Info">
                            <b-card-text>
                                <b-form-group
                                    id="input-group-reseller-permit"
                                    label="Reseller Permit #:"
                                    label-for="input-reseller-permit"
                                    label-size="sm"
                                >
                                    <b-form-input
                                        id="input-reseller-permit"
                                        v-model="edit.resellersPermit"
                                        type="text"
                                        placeholder=""
                                        size="sm"
                                        autocomplete="off"
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Preferred Payment & Delivery">
                            <b-card-text>
                                <b-form-row>
                                    <b-col>
                                        <b-form-group
                                            id="select-group-payment-method"
                                            label="Preferred Payment Method:"
                                            label-for="select-payment-method"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="edit.paymentMethod"
                                                id="select-payment-method"
                                                size="sm"
                                                :options="lists.paymentMethods"
                                            ></b-form-select>
                                        </b-form-group>
                                        <b-form-group
                                            id="select-group-delivery-method"
                                            label="Preferred Delivery Method:"
                                            label-for="select-delivery-method"
                                            label-size="sm"
                                        >
                                            <b-form-select
                                                v-model="edit.deliveryMethod"
                                                id="select-delivery-method"
                                                size="sm"
                                                :options="lists.deliveryMethods"
                                            ></b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col>
                                        <b-form-row>
                                            <b-col>
                                                <b-form-group
                                                    id="input-group-opening-balance"
                                                    label="Opening Balance:"
                                                    label-for="input-opening-balance"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-opening-balance"
                                                        v-model="edit.openingBalance"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <!-- <b-form-group
                                                    id="datepicker-group-opening-balance-date"
                                                    label="as of:"
                                                    label-for="datepicker-opening-balance-date"
                                                    label-size="sm"
                                                >
                                                    <b-form-datepicker
                                                        id="datepicker-opening-balance-date"
                                                        v-model="edit.openingBalanceDate"
                                                        class="mb-2"
                                                        size="sm"
                                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                        locale="en"
                                                    >
                                                    </b-form-datepicker>
                                                </b-form-group> -->
                                            </b-col>
                                        </b-form-row>
                                    </b-col>
                                </b-form-row>
                            </b-card-text>
                        </b-tab>
                        <b-tab title="Cards On File" v-if="$can('view-customer-detail-payment-method') || $can('view-all')">
                            <b-card-text>
                                <b-table-simple hover small fixed bordered>
                                    <b-thead>
                                        <b-th class="default-card"></b-th>
                                        <b-th>Number</b-th>
                                        <b-th>Exp</b-th>
                                        <b-th>CVC</b-th>
                                        <b-th></b-th>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr v-for="(card, index) in lists.cards" :key="index">
                                            <b-td :class="{ 'highlight-green': card.default }" />
                                            <b-td>
                                                <b-form-input :id="'input-cards-number' + row.id" v-model="lists.cards[index].number" type="text" placeholder="" size="sm" autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-cards-exp' + row.id" v-model="lists.cards[index].exp" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-form-input :id="'input-cards-cvc' + row.id" v-model="lists.cards[index].cvc" type="text" placeholder="" size="sm"
                                                    autocomplete="off" disabled />
                                            </b-td>
                                            <b-td>
                                                <b-button class="btn-sm" v-if="!card.default" @click="makeDefault(card.id)">Make Default</b-button>
                                                <b-button variant="danger" class="btn-sm" v-if="!card.default" @click="deleteCard(card.id)">X</b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tbody>
                                    <b-tfoot>
                                        <b-tr>
                                            <b-td></b-td>
                                            <b-td>
                                                <b-form-input id="input-new-number" v-model="edit.new.number" type="text" size="sm" autocomplete="off" />
                                            </b-td>
                                            <b-td>
                                                <b-form-input id="input-new-exp" v-model="edit.new.exp" type="text" size="sm" autocomplete="off" />
                                            </b-td>
                                            <b-td>
                                                <b-form-input id="input-new-cvc" v-model="edit.new.cvc" type="text" size="sm" autocomplete="off" />
                                            </b-td>
                                            <b-td>
                                                <b-button v-if="edit.new.number && edit.new.exp" variant="success" class="btn-sm" @click="createCard">SAVE</b-button>
                                            </b-td>
                                        </b-tr>
                                    </b-tfoot>
                                </b-table-simple>
                            </b-card-text>
                        </b-tab>
                        <!-- <b-tab title="Additional Info">
                            <b-card-text></b-card-text>
                        </b-tab> -->
                        <b-tab title="Sources">
                            <b-card-text>
                                <b-card no-body>
                                    <b-tabs pills card vertical>
                                        <b-tab :title="source.source.name" :active="index == 0" v-for="(source, index) in idTracker" :key="index">
                                            <b-card-text>
                                                <b-table-simple hover small fixed bordered>
                                                    <b-tbody>
                                                        <b-tr>
                                                            <td class="sources-first-col">ID:</td>
                                                            <td>{{ source.source_reference_id }}</td>
                                                        </b-tr>
                                                        <b-tr v-if="source.source.source_type.name == 'WooCommerce' && row.username">
                                                            <td>Username:</td>
                                                            <td>{{ row.username }}</td>
                                                        </b-tr>
                                                        <b-tr v-if="source.source.source_type.name == 'WooCommerce' && row.username">
                                                            <td>E-mail:</td>
                                                            <td>{{ row.email }}</td>
                                                        </b-tr>
                                                        <b-tr v-if="source.source.source_type.name == 'WooCommerce' && row.username">
                                                            <td>Password:</td>
                                                            <td>
                                                                <b-row>
                                                                    <b-col>
                                                                        <b-form-input
                                                                            id="input-reset-password"
                                                                            v-model="newPassword"
                                                                            type="password"
                                                                            placeholder=""
                                                                            size="sm"
                                                                            autocomplete="off"
                                                                        >
                                                                        </b-form-input>
                                                                    </b-col>
                                                                    <b-col>
                                                                        <b-button variant="danger" size="sm" @click="resetPassword(source.sources_id, source.source_reference_id)" :disabled="!newPassword || submittingUnlink == 1">
                                                                            <span v-if="submittingPassword">
                                                                                <b-spinner small type="grow"></b-spinner>
                                                                                Resetting...
                                                                            </span>
                                                                            <span v-else>Reset Password</span>
                                                                        </b-button><br><br>
                                                                        <b-button variant="danger" size="sm" @click="unlinkSource(source.id, source.sources_id, source.source_reference_id)">
                                                                            <span v-if="submittingUnlink">
                                                                                <b-spinner small type="grow"></b-spinner>
                                                                                Unlinking...
                                                                            </span>
                                                                            <span v-else>Unlink Source</span>
                                                                        </b-button>
                                                                    </b-col>
                                                                </b-row>
                                                            </td>
                                                        </b-tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-card-text>
                                        </b-tab>
                                        <b-tab tag="hr" disabled></b-tab>
                                        <b-tab title="Create Woo User" v-if="!row.username">
                                            <b-card-text>
                                                <b-form-group
                                                    id="input-group-new-user-username"
                                                    label="Username:"
                                                    label-for="input-new-user-username"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-new-user-username"
                                                        v-model="newUser.username"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-form-group
                                                    id="input-group-new-user-password"
                                                    label="Password:"
                                                    label-for="input-new-user-password"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-new-user-password"
                                                        v-model="newUser.password"
                                                        type="password"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-button variant="success" size="sm" @click="createNewUser">
                                                    <span v-if="submittingNewUser">
                                                        <b-spinner small type="grow"></b-spinner>
                                                        Creating User...
                                                    </span>
                                                    <span v-else>Create User</span>
                                                </b-button>
                                            </b-card-text>
                                        </b-tab>
                                        <b-tab tag="hr" disabled></b-tab>
                                        <b-tab title="Map Woo User" v-if="!row.username">
                                            <b-card-text>
                                                <b-form-group
                                                    id="input-group-map-userid"
                                                    label="Woo User ID:"
                                                    label-for="input-map-userid"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-map-userid"
                                                        v-model="mapUser.id"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-form-group
                                                    id="input-group-map-username"
                                                    label="Woo Username:"
                                                    label-for="input-map-username"
                                                    label-size="sm"
                                                >
                                                    <b-form-input
                                                        id="input-map-username"
                                                        v-model="mapUser.username"
                                                        type="text"
                                                        placeholder=""
                                                        size="sm"
                                                        autocomplete="off"
                                                    >
                                                    </b-form-input>
                                                </b-form-group>
                                                <b-button variant="success" size="sm" @click="mapUserId">
                                                    <span v-if="submittingMapUserId">
                                                        <b-spinner small type="grow"></b-spinner>
                                                        Mapping User ID...
                                                    </span>
                                                    <span v-else>Map User ID</span>
                                                </b-button>
                                            </b-card-text>
                                        </b-tab>
                                    </b-tabs>
                                </b-card>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-card>
                <b-form-row v-if="$can('edit-customer-detail') || $can('view-all')" class="button-row">
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Updating...
                            </span>
                            <span v-else>Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'row'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-lists-customers-edit-customer',
                edit: {
                    new: []
                },
                newUser: {},
                mapUser: {},
                newPassword: '',
                ready: 0,
                lists: {
                    cards: [],
                    paymentMethods: [
                        'Due On Receipt',
                        'Net 30',
                        'COD MO',
                        'COD CC',
                        'Credit Card'
                    ],
                    deliveryMethods: [
                        'Will Call',
                        'Drop Off',
                        'Ground Shipping',
                        'Expedited Shipping',
                        'LTL Freight',
                        'International Shipping'
                    ],
                    salesReps: [],
                    sources: []
                },
                submitting: 0,
                submittingPassword: 0,
                submittingNewUser: 0,
                submittingUnlink: 0,
                submittingMapUserId: 0
			}
		},

		methods: {
            mapUserId() {
                this.submittingMapUserId = 1

                let url = 'api/lists/customers/mapwoouserid'
                axios.post(url, {
                    id: this.mapUser.id,
                    username: this.mapUser.username,
                    customerId: this.row.id
                })
                .then((res) => {
                    this.submittingMapUserId = 0

                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'User Mapped', 'Woo user mapped successfully!')
                        this.$emit('getRow')
                    } else if (res.data.status == 'duplicate') {
                        this.showAlertBox('error', 'Duplicate Username', 'Username already exists in system. Please try another username!')
                    }
                    // } else if (res.data.status == 'duplicatewoo') {
                    //     this.showAlertBox('error', 'Duplicate Username', 'Username already exists in Woo. Please try another username!')
                    // } else if (res.data.status == 'error') {
                    //     this.showAlertBox('error', 'API Error', res.data.error)
                    // } else {
                    //     this.showAlertBox('error', 'Error', 'Error creating user!')
                    // }
                }, () => {
                    this.has_error = true
                })
            },

            createNewUser() {
                this.submittingNewUser = 1

                let url = 'api/lists/customers/createnewwoouser'
                axios.post(url, {
                    username: this.newUser.username,
                    password: this.newUser.password,
                    customerId: this.row.id
                })
                .then((res) => {
                    this.submittingNewUser = 0

                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'User Created', 'Woo user created successfully!')
                        this.$emit('getRow')
                    } else if (res.data.status == 'duplicate') {
                        this.showAlertBox('error', 'Duplicate Username', 'Username already exists in system. Please try another username!')
                    } else if (res.data.status == 'duplicatewoo') {
                        this.showAlertBox('error', 'Duplicate Username', 'Username already exists in Woo. Please try another username!')
                    } else if (res.data.status == 'error') {
                        this.showAlertBox('error', 'API Error', res.data.error)
                    } else {
                        this.showAlertBox('error', 'Error', 'Error creating user!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            resetPassword(sourceId, wooId) {
                this.submittingPassword = 1

                let url = 'api/lists/customers/resetsourcepassword'
                axios.post(url, {
                    newPassword: this.newPassword,
                    wooId: wooId,
                    username: this.row.username,
                    email: this.row.email,
                    sourceId: sourceId
                })
                .then((res) => {
                    this.submittingPassword = 0

                    if (res.data.status == 'success') {
                        this.newPassword = ''
                        this.showAlertBox('success', 'Password Reset', 'Customer password has been updated successfully!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error updating customer password!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            unlinkSource(trackerId, sourceId, wooId) {
                this.submittingUnlink = 1

                let url = 'api/lists/customers/unlinksource'
                axios.post(url, {
                    wooId: wooId,
                    trackerId: trackerId,
                    sourceId: sourceId
                })
                .then((res) => {
                    this.submittingUnlink = 0

                    if (res.data.status == 'success') {
                        this.getSources()
                        this.$emit('getRow')
                        this.row.username = ''
                        this.row.password = ''
                        this.row.email = ''
                        this.showAlertBox('success', 'Unlink Source', 'Source unlinked from customer successfully!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error unlinking source from customer!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            getSalesReps() {
                let url = 'api/lists/sales-reps/getsalesreps/'
                axios.get(url, {})
                .then((res) => {
                    this.lists.salesReps = res.data.salesReps
                }, () => {
                    this.has_error = true
                })
            },

            getCards() {
                let url = 'api/lists/customers/getcards/' + this.row.id
                axios.get(url, {})
                    .then((res) => {
                        this.lists.cards = res.data.cards
                    }, () => {
                        this.has_error = true
                    })
            },

            getSources() {
                let url = 'api/company/sources/getsources/'
                axios.get(url, {})
                .then((res) => {
                    this.lists.sources = res.data.sources
                }, () => {
                    this.has_error = true
                })
            },

            editCustomer() {
                this.submitting = 1
                let editData = this.edit

                let url = 'api/lists/customers/updatecustomer'
                axios.post(url, {
                    editData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Customer Updated', 'Customer ' + editData.name + ' updated successfully!')
                        this.$emit('getRow')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error updating customer!')
                    }
                }, () => {
                    this.has_error = true
                })
            },

            populateRow() {
                this.edit.id = this.row.id
                this.edit.name = this.row.name
                this.edit.email = this.row.email
                this.edit.buyerName = this.row.buyers_name
                this.edit.phone = this.row.phone
                this.edit.fax = this.row.fax
                this.edit.mobile = this.row.mobile
                this.edit.website = this.row.website
                this.edit.salesRepId = this.row.sales_rep_id
                this.edit.deliveryMethod = this.row.shipping_method
                this.edit.paymentMethod = this.row.payment_method
                this.edit.billingAddress1 = this.row.billing_address_1
                this.edit.billingAddress2 = this.row.billing_address_2
                this.edit.billingCity = this.row.billing_city
                this.edit.billingState = this.row.billing_state
                this.edit.billingZip = this.row.billing_postal_code
                this.edit.billingCountry = this.row.billing_country
                this.edit.shippingAddress1 = this.row.shipping_address_1
                this.edit.shippingAddress2 = this.row.shipping_address_2
                this.edit.shippingCity = this.row.shipping_city
                this.edit.shippingState = this.row.shipping_state
                this.edit.shippingZip = this.row.shipping_postal_code
                this.edit.shippingCountry = this.row.shipping_country
                this.edit.notes = this.row.notes
                this.edit.openingBalance = this.row.starting_balance
                this.edit.resellersPermit = this.row.resellers_permit

                this.ready = 1
            },

            makeDefault(id) {
                let url = 'api/lists/customers/makedefaultcard/' + this.row.id + '/' + id
                axios.get(url, {})
                    .then((res) => {
                        this.getCards()
                    }, () => {
                        this.has_error = true
                    })
            },

            deleteCard(id) {
                let url = 'api/lists/customers/deletecard/' + id
                axios.get(url, {})
                    .then((res) => {
                        this.getCards()
                    }, () => {
                        this.has_error = true
                    })
            },

            createCard() {
                let url = 'api/lists/customers/createcard'
                axios.post(url, {
                    customerId: this.row.id,
                    number: this.edit.new.number,
                    exp: this.edit.new.exp,
                    cvc: this.edit.new.cvc
                })
                    .then((res) => {
                        this.submitting = 0

                        if (res.data.status == 'Success') {
                            this.edit.new = []
                           this.getCards()
                        } else {
                            this.showAlertBox('error', 'Error', 'Error adding card!')
                        }
                    }, () => {
                        this.has_error = true
                    })
            }
		},

		computed: {
            idTracker() {
                return this.row.id_tracker.filter(i => {
                    return i.source.active == 1;
                })
            }
		},

		mounted() {
            this.getSalesReps()
            this.getSources()
            this.populateRow()
            this.getCards()
		}
	}
</script>
<style lang="scss">
    #modal-lists-customers-edit-customer {
        .modal-dialog {
            max-width: 900px;
        }

        .modal-content {
            .default-card {
                width: 1px;
            }

            .highlight-green {
                background-color: green;
            }

            .button-row {
                margin-top: 15px;
            }

            .sources-first-col {
                width: 105px;
            }
        }
    }
</style>
